import {useAtomValue} from 'jotai';
import {useMemo} from 'react';
import {useGA4WithParams} from '@/hooks/tracking';
import {anaysisListAtom} from '@/map/atom';
import {AREA_OVERLAY_TYPE_TEXT} from '@/map/constants';
import {useAiPromptStack} from './hook';
import {HowToUse} from './HowToUse';
import {AiPromptPanel} from './Panel';
import {PromptMessage} from './PromptMessage';

interface IProps {
  map?: naver.maps.Map;
}

export const AiPrompt = ({map}: IProps) => {
  const {activeAiPropmptItem, toggleAiPrompt} = useAiPromptStack();
  const tracking = useGA4WithParams();

  const anaysisList = useAtomValue(anaysisListAtom);
  const analysisType = useMemo(() => {
    const item = anaysisList.find((i) => i.id === activeAiPropmptItem?.id);

    return item ? AREA_OVERLAY_TYPE_TEXT[item.type] : undefined;
  }, [anaysisList, activeAiPropmptItem?.id]);

  const onClose = () => {
    toggleAiPrompt();
    tracking('AI_analysis_close', {analysis_type: analysisType});
  };

  return (
    <AiPromptPanel {...activeAiPropmptItem} onClose={onClose}>
      {activeAiPropmptItem?.id ? (
        // 분석 영역이 바뀌면 진행률·스크롤 위치가 섞이지 않도록 새로 마운트한다
        <PromptMessage
          key={activeAiPropmptItem.id}
          map={map}
          id={activeAiPropmptItem.id}
          open={activeAiPropmptItem.open}
          analysisType={analysisType}
        />
      ) : (
        <HowToUse />
      )}
    </AiPromptPanel>
  );
};
